// src/components/ui/Divider.jsx
import React from "react";
import { cn } from "../../utils/cn";

/**
 * Divider
 * Props:
 *  - variant: "outline" | "outlineVariant" (defaults to outline)
 *  - inset: boolean (left inset used inside cards)
 *  - insetStart / insetEnd: exact divider offsets in px or CSS length
 *  - full: boolean (bleed to container edges, e.g. under search)
 */
function toCssLength(value) {
  if (value == null) return undefined;
  return typeof value === "number" ? `${value}px` : value;
}

export default function Divider({
  variant = "outline",
  inset = false,
  insetStart,
  insetEnd,
  full = false,
  className,
}) {
  const style = {
    background:
      variant === "outlineVariant"
        ? "var(--Schemes-Outline-Variant, rgb(var(--clr-outline-variant)))"
        : "var(--Schemes-Outline, rgb(var(--clr-outline)))",
  };

  const resolvedInsetStart = insetStart ?? (inset ? 16 : null);
  const resolvedInsetEnd = insetEnd ?? (inset ? 0 : null);

  if (resolvedInsetStart != null) style.marginLeft = toCssLength(resolvedInsetStart);
  if (resolvedInsetEnd != null) style.marginRight = toCssLength(resolvedInsetEnd);

  return (
    <div
      className={cn(
        "h-px",
        full && "mx-[-1rem] sm:mx-[-1.5rem]", // bleed to page paddings (px-4 / sm:px-6)
        className
      )}
      style={style}
    />
  );
}
